import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, Clock } from "lucide-react";

interface WaitlistDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userEmail?: string;
  persona?: 'investor' | 'advisor' | 'asset_manager';
}

export function WaitlistDialog({ open, onOpenChange, userEmail, persona }: WaitlistDialogProps) {
  const title = persona === 'advisor'
    ? "Advisor Waitlist"
    : persona === 'asset_manager'
      ? "Asset Manager Waitlist"
      : "You're on the Waitlist";

  const description = persona === 'advisor'
    ? "Thanks for your interest. We’re onboarding advisors in cohorts. We’ll reach out with next steps."
    : persona === 'asset_manager'
      ? "We’re preparing institutional onboarding. We’ll contact you to coordinate access."
      : "Thanks for your interest! New account creation is currently limited as we're in pre-release.";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-2 mb-2">
            <Clock className="h-5 w-5 text-warning" />
            <DialogTitle>{title}</DialogTitle>
          </div>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {userEmail && (
            <div className="flex items-center gap-2 p-3 bg-muted rounded-lg">
              <CheckCircle className="h-4 w-4 text-success" />
              <span className="text-sm">
                We've added <strong>{userEmail}</strong> to our waitlist.
              </span>
            </div>
          )}
          <p className="text-sm text-muted-foreground">
            If you already have an account, please try signing in with your email and password instead.
          </p>
        </div>
        <div className="flex justify-end">
          <Button onClick={() => onOpenChange(false)}>
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}